import ContentBox from 'components/ContentBox';

export default ContentBox({
  name: 'PaginationContainer',
  contentKey: 'pagination',
});
